import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "../Psicopedagogico/moduloPiscologiaIngreso.css";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import axios from "axios";

function ModuloCompletoPerfeccionamiento({ datos, refres, etapa }) {
  const [selected, setSelected] = useState(null);
  const [nuevaObservacion, setNuevaObservacion] = useState("");
  const [observacionesAnteriores, setObservacionesAnteriores] = useState("");
  const [personaSeleccionada, setPersonaSeleccionada] = useState(null);
  const [evaluacionExistente, setEvaluacionExistente] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);

  const Usuario = ObtieneDatosCookies();

  const itemIdFinal =
    datos?.item?.id ||
    datos?.item?.item_id ||
    datos?.item?.idItem ||
    datos?.item;

  /* =========================================================
     ACTUALIZAR PERSONA SELECCIONADA
     ========================================================= */

  useEffect(() => {
    if (datos?.persona) {
      setPersonaSeleccionada(datos.persona);
    }
  }, [datos]);

  /* =========================================================
     CONSULTAR EVALUACIÓN EXISTENTE
     ========================================================= */

  useEffect(() => {
    let mounted = true;

    const fetchEvaluacion = async () => {
      setCargando(true);

      try {
        const res = await axios.post(
          "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/getEvaluacionItem",
          {
            dni: datos?.persona?.dni,
            item_id: itemIdFinal,
          },
          {
            withCredentials: true,
          }
        );

        const data = res.data;

        if (!mounted) return;

        if (data?.evaluacion) {
          const estadoActual = String(
            data.evaluacion.estado || ""
          ).toLowerCase();

          setSelected(
            estadoActual === "aprobado" ? "apto" : "noapto"
          );

          setObservacionesAnteriores(
            data.evaluacion.observaciones || ""
          );

          setEvaluacionExistente(true);
        } else {
          setSelected(null);
          setObservacionesAnteriores("");
          setEvaluacionExistente(false);
        }

        // Siempre se limpia para escribir una observación nueva.
        setNuevaObservacion("");
      } catch (error) {
        console.error(
          "Error al consultar evaluación:",
          error
        );

        console.error(
          "Respuesta backend:",
          error?.response?.data
        );

        console.error(
          "Status:",
          error?.response?.status
        );

        if (mounted) {
          Swal.fire(
            "Error",
            error?.response?.data?.message ||
              "No se pudo consultar la evaluación anterior",
            "error"
          );
        }
      } finally {
        if (mounted) {
          setCargando(false);
        }
      }
    };

    if (datos?.persona?.dni && itemIdFinal) {
      fetchEvaluacion();
    }

    return () => {
      mounted = false;
    };
  }, [datos?.persona?.dni, itemIdFinal]);

  /* =========================================================
     FECHA ACTUAL
     ========================================================= */

  const obtenerFechaActual = () => {
    return new Intl.DateTimeFormat("es-AR", {
      timeZone: "America/Argentina/Buenos_Aires",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(new Date());
  };

  /* =========================================================
     GUARDAR / ACTUALIZAR EVALUACIÓN
     ========================================================= */

  const handleGuardar = async () => {
    if (!personaSeleccionada) {
      Swal.fire(
        "Error",
        "No hay persona cargada",
        "error"
      );
      return;
    }

    if (!itemIdFinal || typeof itemIdFinal === "object") {
      Swal.fire(
        "Error",
        "El item_id no es válido",
        "error"
      );

      console.error(
        "ITEM INVÁLIDO:",
        datos?.item
      );

      return;
    }

    if (!selected) {
      Swal.fire(
        "Error",
        "Seleccioná APTO o NO APTO",
        "error"
      );
      return;
    }

    /* =========================================================
       DATOS DEL EVALUADOR
       ========================================================= */

    const evaluador = Usuario
      ? `${Usuario.identificacion} ${Usuario.apellido}, ${Usuario.nombre} (SEDE: ${Usuario.sedeID})`
      : "sistema";

    /* =========================================================
       NUEVA ENTRADA DEL HISTORIAL
       ========================================================= */

    const nuevaEntrada = [
      "========================================",
      `Fecha: ${obtenerFechaActual()}`,
      `Resultado: ${selected.toUpperCase()}`,
      `Nueva observación: ${
        nuevaObservacion.trim() ||
        "Sin nueva observación"
      }`,
      `Evaluador: ${evaluador}`,
    ].join("\n");

    /* =========================================================
       CONCATENAR OBSERVACIONES
       ========================================================= */

    const observacionesCompletas =
      observacionesAnteriores.trim()
        ? `${observacionesAnteriores.trim()}\n\n${nuevaEntrada}`
        : nuevaEntrada;

    /* =========================================================
       PAYLOAD
       ========================================================= */

    const payload = {
      persona_id:
        personaSeleccionada.id ||
        personaSeleccionada.dni,

      item_id: Number(itemIdFinal),

      estado:
        selected === "apto"
          ? "aprobado"
          : "rechazado",

      tipo: "evaluacion",

      resultado: selected,

      observaciones: observacionesCompletas,

      proceso_id:
        etapa?.etapa_proceso_id ||
        etapa?.proceso_id ||
        datos?.proceso_id ||
        1,
    };

    /* =========================================================
       CONFIRMACIÓN
       ========================================================= */

    const result = await Swal.fire({
      title: evaluacionExistente
        ? "¿Actualizar evaluación?"
        : "¿Confirmar evaluación?",

      html: `
        <div style="text-align:left">

          <b>Persona:</b>
          ${personaSeleccionada.nombre || ""}
          (${personaSeleccionada.dni})
          <br/>

          <b>Resultado:</b>
          ${selected.toUpperCase()}
          <br/>

          <b>Nueva observación:</b>
          ${
            nuevaObservacion.trim()
              ? nuevaObservacion
              : "Sin nueva observación"
          }

          ${
            evaluacionExistente
              ? `
                <br/><br/>

                <span style="color:#92400e">
                  <b>
                    La evaluación existente será actualizada
                    y se conservarán las observaciones anteriores.
                  </b>
                </span>
              `
              : ""
          }

        </div>
      `,

      icon: "warning",

      showCancelButton: true,

      confirmButtonText:
        evaluacionExistente
          ? "Actualizar"
          : "Guardar",

      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    setGuardando(true);

    /* =========================================================
       GUARDAR CON AXIOS
       ========================================================= */

    try {
      const res = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/togglePersonaItem",
        payload,
        {
          withCredentials: true,
        }
      );

      const data = res.data;

      console.log(
        "Respuesta togglePersonaItem:",
        data
      );

      /* =========================================================
         ACTUALIZAR ESTADO LOCAL
         ========================================================= */

      setObservacionesAnteriores(
        observacionesCompletas
      );

      setNuevaObservacion("");

      setEvaluacionExistente(true);

      /* =========================================================
         MENSAJE
         ========================================================= */

      await Swal.fire(
        "Guardado",
        evaluacionExistente
          ? "La evaluación fue actualizada correctamente"
          : "La evaluación fue registrada correctamente",
        "success"
      );

      /* =========================================================
         REFRESCAR PADRE
         ========================================================= */

      if (typeof refres === "function") {
        refres();
      }
    } catch (error) {
      console.error(
        "Error al guardar evaluación:",
        error
      );

      console.error(
        "Respuesta backend:",
        error?.response?.data
      );

      console.error(
        "Status:",
        error?.response?.status
      );

      Swal.fire(
        "Error",
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          error.message ||
          "No se pudo guardar la evaluación",
        "error"
      );
    } finally {
      setGuardando(false);
    }
  };

  /* =========================================================
     SIN DATOS
     ========================================================= */

  if (!datos || !datos.persona) {
    return <div>Cargando datos...</div>;
  }

  /* =========================================================
     RENDER
     ========================================================= */

  return (
    <div className="psico-card">

      <h1 className="psico-titulo">
        EVALUACIÓN {etapa?.nombre || ""}
      </h1>

      {/* =====================================================
          AVISO EVALUACIÓN EXISTENTE
          ===================================================== */}

      {evaluacionExistente && (
        <div
          style={{
            background: "#fef3c7",
            color: "#92400e",
            padding: 10,
            borderRadius: 8,
            textAlign: "center",
            fontWeight: "bold",
            marginBottom: 12,
          }}
        >
          Esta persona ya posee una evaluación.
          Puede modificar el resultado y agregar
          una nueva observación.
        </div>
      )}

      {/* =====================================================
          PERSONA
          ===================================================== */}

      <div className="psico-info">
        <strong>Evaluando a:</strong>{" "}
        {personaSeleccionada?.nombre} (
        {personaSeleccionada?.dni})
      </div>

      {/* =====================================================
          CARGANDO
          ===================================================== */}

      {cargando ? (
        <div
          style={{
            padding: 15,
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          Cargando evaluación...
        </div>
      ) : (
        <>

          {/* =================================================
              APTO / NO APTO
              ================================================= */}

          <div className="psico-grupo">

            <button
              type="button"
              disabled={guardando}
              className={`psico-btn psico-apto ${
                selected === "apto"
                  ? "psico-active"
                  : ""
              }`}
              onClick={() =>
                setSelected("apto")
              }
            >
              APTO
            </button>

            <button
              type="button"
              disabled={guardando}
              className={`psico-btn psico-noapto ${
                selected === "noapto"
                  ? "psico-active"
                  : ""
              }`}
              onClick={() =>
                setSelected("noapto")
              }
            >
              NO APTO
            </button>

          </div>

          {/* =================================================
              HISTORIAL
              ================================================= */}

          {observacionesAnteriores && (
            <div
              style={{
                marginBottom: 15,
              }}
            >
              <label
                style={{
                  display: "block",
                  fontWeight: "bold",
                  marginBottom: 6,
                }}
              >
                Historial de observaciones
              </label>

              <textarea
                readOnly
                value={
                  observacionesAnteriores
                }
                style={{
                  width: "100%",
                  minHeight: "180px",
                  cursor: "default",
                  background: "#f3f4f6",
                  color: "#374151",
                }}
              />
            </div>
          )}

          {/* =================================================
              NUEVA OBSERVACIÓN
              ================================================= */}

          <div
            style={{
              marginBottom: 15,
            }}
          >
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                marginBottom: 6,
              }}
            >
              Nueva observación
            </label>

            <textarea
              disabled={guardando}
              placeholder="Escriba aquí la nueva observación que se agregará al historial"
              style={{
                width: "100%",
                minHeight: "120px",
                cursor: guardando
                  ? "not-allowed"
                  : "text",
              }}
              value={nuevaObservacion}
              onChange={(e) =>
                setNuevaObservacion(
                  e.target.value
                )
              }
            />
          </div>

          {/* =================================================
              GUARDAR
              ================================================= */}

          <button
            type="button"
            className="psico-btn-guardar"
            onClick={handleGuardar}
            disabled={
              guardando ||
              cargando ||
              !selected ||
              !personaSeleccionada
            }
          >
            {guardando
              ? "GUARDANDO..."
              : evaluacionExistente
              ? "ACTUALIZAR EVALUACIÓN"
              : "GUARDAR EVALUACIÓN"}
          </button>

        </>
      )}

    </div>
  );
}

export default ModuloCompletoPerfeccionamiento;